import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Generate or retrieve session ID for analytics
const getAnalyticsSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

// Track custom event
export const trackEvent = async (eventType, eventData = {}) => {
  try {
    await axios.post(`${API}/analytics/event`, {
      event_type: eventType,
      event_data: eventData,
      page_url: window.location.href,
      session_id: getAnalyticsSessionId(),
      user_id: localStorage.getItem('user_id') || null
    });
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

// Track page view
export const trackPageView = async () => {
  try {
    await axios.post(`${API}/analytics/pageview`, {
      page_url: window.location.href,
      referrer: document.referrer,
      session_id: getAnalyticsSessionId(),
      user_id: localStorage.getItem('user_id') || null
    });
  } catch (error) {
    console.error('Pageview tracking error:', error);
  }
};

// Track button click
export const trackButtonClick = (buttonName, additionalData = {}) => {
  trackEvent('button_click', { button_name: buttonName, ...additionalData });
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
  trackEvent('scroll_depth', { depth_percentage: depth });
};

// Track time on page
export const trackTimeOnPage = (seconds) => {
  trackEvent('time_on_page', { duration_seconds: seconds });
};

// Initialize analytics
export const initAnalytics = () => {
  // Track initial page view
  trackPageView();

  // Track scroll depth
  let maxScroll = 0;
  const trackScroll = () => {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = Math.round((window.scrollY / scrollHeight) * 100);
    
    if (scrollPercentage > maxScroll && scrollPercentage % 25 === 0) {
      maxScroll = scrollPercentage;
      trackScrollDepth(scrollPercentage);
    }
  };
  window.addEventListener('scroll', trackScroll);

  // Track time on page when leaving
  const startTime = Date.now();
  window.addEventListener('beforeunload', () => {
    const timeOnPage = Math.round((Date.now() - startTime) / 1000);
    trackTimeOnPage(timeOnPage);
  });
};
